import React, { useState, useContext } from 'react';
import { FooterItems } from '../Presentation/FooterItems';
import { isEmptyEvery, getValueOrDefaultObject } from 'common/utilities/utils';
import { setAnalyticsData } from 'organisms/StartOrderComponent/StartOrderUtilities/startOderUtils';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { LOCAL_STORAGE_KEYS, ROUTE_URL, TO_CATERING_NAV, TO_MENU_NAV } from 'common/constants/SharedConstants';
import { UserOrderContext } from 'context/context';
import { useSelector, useDispatch } from 'react-redux';
import OrderLookup from '../Presentation/orderLookUp';
import { clearPastOrderAction } from '@kfc-global/react-shared/redux/Actions/orderAction';
import FOOTER_CONSTANT from '../FooterConstants/FooterConstant';
import {
  CateringMenuNavigationHandler,
  checkIfCateringPage,
  ifCateringNavigationHappened,
} from 'common/utilities/CateringPLPUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import CartAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

let getOnFooterItemSelectProps = {};

/**
 * Method to hold user footer item click
 */

export const onFooterItemSelect = selectedFooterItem => {
  const { linkTo, name, titleText, event } = selectedFooterItem;
  const {
    allowedLanguages,
    LANGUAGE_SELECTOR,
    userOrderStateDispatch,
    ORDER_LOOKUP_NAME,
    setOpen,
    dispatch,
    FIND_A_KFC_TITLE,
    userParams,
    dispositionNew,
    CATERING_NAVALERT_TITLE,
    CATERING_NAVALERT_SUBTITLE,
    MENU_NAVALERT_TITLE,
    MENU_NAVALERT_SUBTITLE,
    history,
  } = getOnFooterItemSelectProps;
  event.preventDefault();
  event.stopPropagation();

  setAnalyticsData({ footerItemSelected: name });

  if (selectedFooterItem === 'Language Selector' && allowedLanguages?.length > 1) {
    userOrderStateDispatch({ type: LANGUAGE_SELECTOR, value: { showLanguageSelector: true } });
    setTimeout(() => {
      document.getElementById('language_selector') && document.getElementById('language_selector').focus();
    }, 0);
  }
  if (name === ORDER_LOOKUP_NAME) {
    setOpen(true);
    dispatch(clearPastOrderAction({}));
    // } else if (name === FOOTER_MENU && linkTo) {
    //   navigateToUrl(linkTo);
  } else if (titleText?.toLowerCase() === FIND_A_KFC_TITLE?.toLowerCase()) {
    history.push({
      pathname: ROUTE_URL.FIND_STORE,
    });
  } else if (linkTo) {
    //if user is localized and menupage navigation is happening make usernonlocalized and clear cart
    let checkMenuNavigation = ifCateringNavigationHappened(userParams.localized, dispositionNew?.type, linkTo);
    switch (checkMenuNavigation) {
      case TO_CATERING_NAV:
        userOrderStateDispatch({
          type: START_ORDER_CONSTANTS.UPDATE_CATERING_RETAIL_MENU_ALERT,
          value: {
            flag: true,
            pathname: linkTo,
            title: CATERING_NAVALERT_TITLE,
            contentMsg: CATERING_NAVALERT_SUBTITLE,
          },
        });
        break;
      case TO_MENU_NAV:
        userOrderStateDispatch({
          type: START_ORDER_CONSTANTS.UPDATE_CATERING_RETAIL_MENU_ALERT,
          value: {
            flag: true,
            pathname: linkTo,
            title: MENU_NAVALERT_TITLE,
            contentMsg: MENU_NAVALERT_SUBTITLE,
          },
        });
        break;
      default:
        history.push({
          pathname: linkTo,
        });
        break;
    }
  }
};
/**
 * Main Container for Entire Footer Components
 * @param - json data from content side
 */

export const Footer = props => {
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { contentData = [], tenantReducerData, history } = props;
  const { LANGUAGE_SELECTOR } = START_ORDER_CONSTANTS;
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { allowedLanguages = [] } = tenantReducer?.basic || {};
  const [openModal, setOpen] = useState(false);
  const { ORDER_LOOKUP_NAME, FIND_A_KFC_TITLE } = FOOTER_CONSTANT;
  const userParams = useSelector(state => state?.appStateReducer?.userStatus);
  const {
    CATERING_NAVALERT_TITLE,
    CATERING_NAVALERT_SUBTITLE,
    MENU_NAVALERT_TITLE,
    MENU_NAVALERT_SUBTITLE,
    KEEP_ORDER,
    START_NEW_ORDER,
  } = TRANSLATE_MAPPING_KEY;
  const dispatch = useDispatch();
  const { alertModalData = {} } = userOrderState;
  const { tenantId } = tenantReducer;
  const cartReducer = useSelector(data => data.cartReducer);
  const { CartError } = IMAGE_PATH;

  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW))
    : userOrderState.dispositionNew;
  const { cartData = {} } = getValueOrDefaultObject(cartReducer);

  getOnFooterItemSelectProps = {
    allowedLanguages: allowedLanguages,
    LANGUAGE_SELECTOR: LANGUAGE_SELECTOR,
    userOrderStateDispatch: userOrderStateDispatch,
    ORDER_LOOKUP_NAME: ORDER_LOOKUP_NAME,
    setOpen: setOpen,
    dispatch: dispatch,
    FIND_A_KFC_TITLE: FIND_A_KFC_TITLE,
    userParams: userParams,
    dispositionNew: dispositionNew,
    CATERING_NAVALERT_TITLE: CATERING_NAVALERT_TITLE,
    CATERING_NAVALERT_SUBTITLE: CATERING_NAVALERT_SUBTITLE,
    MENU_NAVALERT_TITLE: MENU_NAVALERT_TITLE,
    MENU_NAVALERT_SUBTITLE: MENU_NAVALERT_SUBTITLE,
    history: history,
  };

  const onNavigateToHome = () => {
    history.push({
      pathname: '/',
    });
    window.scrollTo(0, 0);
  };

  const handleClose = () => {
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.UPDATE_CATERING_RETAIL_MENU_ALERT,
      value: {
        flag: false,
        pathname: '',
        title: '',
        contentMsg: '',
      },
    });
  };
  const onConfirmHandler = () => {
    //call util function
    CateringMenuNavigationHandler(
      cartData?.id,
      tenantId,
      userParams,
      dispatch,
      userOrderStateDispatch,
      checkIfCateringPage(alertModalData.pathname),
      dispositionNew,
    );
    //navigate to required page
    history.push({
      pathname: alertModalData.pathname,
    });
    //close disposition
    handleClose();
  };

  return (
    <div>
      <div className='footer au' data-testid='FooterItems-component' role='contentinfo'>
        <FooterItems
          contentData={contentData}
          clickHandler={onFooterItemSelect}
          tenantReducerData={tenantReducerData}
          navigateHandler={onNavigateToHome}
          data-testid='footer-items'
        />
      </div>
      {openModal && (
        <OrderLookup isOpen={true} handleClose={() => setOpen(false)} tenantReducerData={tenantReducerData} />
      )}
      {alertModalData.flag ? (
        <CartAlertFormInsideModel
          handleClose={handleClose}
          classNames='clear-cart-modal item-unavailable catering-menu-nav-alert'
          CartAlertForm={
            <CartAlertForm
              title={translateWithI18Next(alertModalData.title)}
              contentMsg={translateWithI18Next(alertModalData.contentMsg)}
              imageSrc={CartError}
              altText={''}
              confirmButtonText={translateWithI18Next(START_NEW_ORDER)}
              confirmHandler={onConfirmHandler}
              cancelButtonText={translateWithI18Next(KEEP_ORDER)}
              cancelHandler={handleClose}
            />
          }
        />
      ) : (
        <></>
      )}
    </div>
  );
};
export default Footer;
